import cssUtil from 'gw-portals-util-js/CssUtil';

import template from 'text!./SimpleList.html';
import styles from './SimpleList-hashed.scss';

export default (function () {
    return {
        restrict: 'E',
        scope: {
            scheduledItem: '<'
        },
        template: cssUtil.hashTemplate(template, styles)
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/MobileViewGenerator/subdirectives/list/SimpleList/SimpleList.js
// module id = 273
// module chunks = 0